import { jsx as _jsx } from "react/jsx-runtime";
import DocumentIcon from '@heroicons/react/outline/DocumentIcon';
import { Card } from '@tribeplatform/react-ui-kit/Card';
import { EmptyState as EmptyStateComponent } from '@tribeplatform/react-ui-kit/EmptyState';
import { useI18n } from '../i18n';
export const EmptyState = () => {
    const intl = useI18n();
    return (_jsx(Card, { children: _jsx(Card.Content, { children: _jsx("div", { className: "my-16", children: _jsx(EmptyStateComponent, { title: intl.$t({
                        id: 'Generics.NothingHere',
                        defaultMessage: 'Nothing here!',
                    }), icon: _jsx(DocumentIcon, {}, void 0) }, void 0) }, void 0) }, void 0) }, void 0));
};
//# sourceMappingURL=EmptyState.js.map